
import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import OpenMapsButton from './OpenMapsButton';
// commit1
function withLineBreaks(text) {
    // check for <br /> or /n or /r/n
    const lineBreakSymbols = /<br\s*\/?>|\r?\n/i;
    return text.split(lineBreakSymbols).join("<br />");
}

export default function ExpandedEvent({ event, handleBack }) {

    const location = useLocation();

    if (event === undefined) return (
        <div className="event">
            <button
                className="event-back"
                onClick={() => handleBack()}
            >
                <div className="btn-icon-circle">
                    {/* Left Caret Icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" style={{marginLeft: -2}}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                    </svg>
                </div>
            </button>
            <span style={{ fontSize: "1.5rem", alignSelf: 'center', marginTop: 160 }}>
                That event could not be found!
            </span>
        </div>
    )

    const fullUrl = `${window.location.origin}${location.pathname}${location.search}`;
    
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: event.summary,
                    text: "View this event on SocalFurs!",
                    url: fullUrl
                });
            } catch (error) {
                if (error.name !== "AbortError") console.log("There was a problem.")
            }
        } else {    
            alert("Your browser doesn't support this.");
        }
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(fullUrl)
            .then(() => {
                console.log("Copied!")
            })
            .catch(err => {
                alert("There was a problem.");
            })
    }

    console.log("THIS IS OUR EVENT DETAILS")
    console.log(event.lat)
    console.log(event.lon)
    return (
        
        <div className="event">
            
  
            <button
                className="event-back"
                onClick={() => handleBack()}
            >
                <div className="btn-icon-circle">
                    {/* Left Caret Icon */}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" style={{marginLeft: -2}}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                    </svg>
                </div>
            </button>
            <span className="event-header">{event.summary}</span>
            <div className="event-info-line">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="rgb(60, 163, 204)">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                </svg>
                <span>{event.location}</span>
            </div>
            <div className="event-info-line">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="rgb(60, 163, 204)">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
                <span>{event.date}</span>
            </div>
            {event.lat == 0 && event.lng == 0 && (
                <div className="event-warning">
                    This event could not be displayed on the map! Please search for the location above.
                </div>
            )}
            <div className="event-page-description">
                <h6>Description</h6>
                <span dangerouslySetInnerHTML={{__html: withLineBreaks(event.description.replace(/\?{4,}/g, ''))}}></span>
            </div>
            <OpenMapsButton lat={event.lat} lon={event.lng} name={event.summary} />
            <Link className='event-action' to={event.htmlLink}>
                <button>See on Google Calendar</button>
            </Link>
            <Link className='event-action' to={"https://t.me/+LPKHccQiNR03ZDQ7"}>
                <button>Join the Telegram</button>
            </Link>
            {navigator.share && (
                <button onClick={handleShare} className='share-btn'>
                    Share Event
                </button>
            )}
            {navigator.clipboard && (
                <div className="sharelink">
                    <input
                        type="text"
                        value={fullUrl}
                        readOnly
                    />
                    <button onClick={handleCopy}>Copy</button>
                </div>
            )}
        </div>
    )
}
